import { render, staticRenderFns } from "./AccountAppid.vue?vue&type=template&id=2e677c31&"
import script from "./AccountAppid.vue?vue&type=script&lang=js&"
export * from "./AccountAppid.vue?vue&type=script&lang=js&"
import style0 from "./AccountAppid.vue?vue&type=style&index=0&id=2e677c31&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e677c31')) {
      api.createRecord('2e677c31', component.options)
    } else {
      api.reload('2e677c31', component.options)
    }
    module.hot.accept("./AccountAppid.vue?vue&type=template&id=2e677c31&", function () {
      api.rerender('2e677c31', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/AccountAppid.vue"
export default component.exports